import ManageDonation from "./container";

export default ManageDonation;
